import { useHasMultipleStorePlatformsQuery } from "@shared/data/queries/HasMultipleStorePlatformsQuery/HasMultipleStorePlatforms.query";

import { useSharedGlobalConfig } from "../useSharedGlobalConfig/useSharedGlobalConfig";

const useSonicSegmentProvidersExperiment = () => {
  const { isEmerson, isUnauthenticated } = useSharedGlobalConfig();
  const { data: officeData } = useHasMultipleStorePlatformsQuery({ skip: isUnauthenticated });
  const { hasMultipleStorePlatforms } = officeData?.currentOffice?.user ?? {};

  return !isEmerson && !hasMultipleStorePlatforms;
};

export { useSonicSegmentProvidersExperiment };
